import Types from "../actions/types";
import { of } from "rxjs";
import { ofType } from "redux-observable";
import { tap, mapTo, filter } from "rxjs/operators";
import { push } from "connected-react-router";
import {
	tokenExists,
	routeNotWhitelisted,
	setBaseUrl,
	setWebsiteBaseUrl,
} from "frame";
import { onLogout } from "../actions";
import * as fromAuth from "features/authorisation";

const initialiseEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.FRAME_INITIALISE_REQUESTED),
		tap(() => {
			setBaseUrl();
			setWebsiteBaseUrl();
		}),
		filter(() => !tokenExists()),
		filter(
			() => !routeNotWhitelisted(state$.value.router.location.pathname)
		),
		// If token is missing/expired, force a real logout to clear any stale persisted state
		// (e.g. impersonation/profile state that can make the UI look "logged in").
		mapTo(onLogout())
	);

export default initialiseEffect;
